// @owners { team: patients-team }
import React, { useState } from 'react';
// eslint-disable-next-line import/no-deprecated
import { setSudo } from '~shared/actions/auth';
import getSudoError from '~shared/selectors/ui/errors/getSudoError';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { ReauthActionSheet } from '~web/features/profile/components/ReauthActionSheet';

type Props = {
  readonly onReauth: () => void;
};

export const ReauthRequired = ({ onReauth }: Props) => {
  const dispatch = useDispatchShared();
  const [sudoState, setSudoState] = useState(false);
  const sudoError = useSelectorShared(getSudoError);

  const submitPassword = async ({ password }: { password: string }) => {
    // eslint-disable-next-line import/no-deprecated
    const { sudo } = await dispatch(setSudo(password));
    if (sudo) {
      setSudoState(sudo);
      onReauth();
    }
  };

  if (!sudoState) {
    return (
      <ReauthActionSheet
        onSubmit={submitPassword}
        error={sudoError}
      />
    );
  }

  return null;
};
